import {
  getMarketingSettingsQuery,
  marketingSettingsSubscribeMutation,
  setMarketingSettingsQuery,
} from '../graphql/queries/multibss/marketing-settings.query';
import { ApiResponse, query } from './api';
import { MarketingSettings, MarketingSettingsSubscribeType } from './marketing-settings.types';

interface MarketingSettingsApiInterface {
  getMarketingSettings(billingCustomerId: string): ApiResponse<MarketingSettings[]>;
  updateMarketingSettings(
    billingCustomerId: string,
    marketingSettings: MarketingSettings[]
  ): ApiResponse<{ success: boolean }>;
  changeMarketingSettingsSubscription(
    token: string,
    type: MarketingSettingsSubscribeType,
    subscribe: boolean
  ): ApiResponse<{ success: boolean }>;
}

const MarketingSettingsApi: MarketingSettingsApiInterface = {
  getMarketingSettings(billingCustomerId: string) {
    return query<{ getMarketingSettings: MarketingSettings[] }>({
      query: getMarketingSettingsQuery,
      variables: {
        billingCustomerId,
      },
      name: 'getMarketingSettings',
    }).then(({ getMarketingSettings }) => ({ data: getMarketingSettings }));
  },
  async updateMarketingSettings(billingCustomerId: string, marketingSettings: MarketingSettings[]) {
    const { setMarketingSettings } = await query<{ setMarketingSettings: { success: boolean } }>({
      query: setMarketingSettingsQuery,
      variables: {
        billingCustomerId,
        marketingSettings,
      },
      name: 'setMarketingSettings',
    });

    return { data: setMarketingSettings };
  },
  async changeMarketingSettingsSubscription(
    token: string,
    type: MarketingSettingsSubscribeType,
    subscribe: boolean
  ): ApiResponse<{ success: boolean }> {
    const { changeMarketingSettingsSubscription } = await query<{
      changeMarketingSettingsSubscription: { success: boolean };
    }>(
      {
        query: marketingSettingsSubscribeMutation,
        variables: { token, type, subscribe },
        name: 'changeMarketingSettingsSubscription',
      },
      false
    );

    return { data: changeMarketingSettingsSubscription };
  },
};

export { MarketingSettingsApi };
